module.exports = __webpack_public_path__ + "assets/img/menu_bg_3.22e5b7e4.png";